export { MarketFaqPage } from './MarketFaqPage'
export type { MarketFaqPageProps } from './MarketFaqPage'
